const getCompleteDateRange = (startDate: Date, endDate: Date): Date[] => {
  const completeRange: Date[] = [];
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    completeRange.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return completeRange;
};

export default getCompleteDateRange;
